/* Batch 34 · Z-11 — the period a GL-based sampling population was drawn from (current period only) and how many prior-year
   rows were left out, on the sample's row. STEP 2 · A7: and the rows tagged current but dated outside the period (left out
   of this population and of JE testing), with their list. */
import React from "react";
import { fmtDate } from "@/lib/dt";
import OutOfPeriodRows from "@/components/OutOfPeriodRows";
import { fmtCount } from "@/components/Amount";   // STEP 3 combined · B6b: the one count formatter (Western digits)

export default function PopulationPeriodLine({ sample, t, lang }) {
  const pp = sample?.stats?.population_period;
  if (!pp) return null;
  const label = pp.period_start && pp.period_end ? `${fmtDate(pp.period_start)} – ${fmtDate(pp.period_end)}` : "";
  return (
    <div className="text-[10px] text-muted-foreground" data-testid={`sample-pop-period-${sample.id}`}>
      {t("b34a.popPeriod").replace("{label}", label).trim()}
      {pp.prior_rows_excluded > 0 && ` · ${t("b34a.popPriorExcluded").replace("{n}", fmtCount(pp.prior_rows_excluded))}`}
      <OutOfPeriodRows count={pp.out_of_period_rows_excluded} rows={pp.out_of_period_rows} context="sampling" t={t} lang={lang}
                       testid={`sample-out-of-period-${sample.id}`} />
    </div>
  );
}
